import { analyticsBatcher } from './analyticsBatcher';

/**
 * Track form submissions with batching
 */
export const trackFormSubmission = (formName: string, formId?: string) => {
  analyticsBatcher.addEvent({
    action: 'form_submit',
    category: 'engagement',
    label: formName,
    custom_parameters: {
      form_id: formId,
    }
  });
};

/**
 * Track form success events
 */
export const trackFormSuccess = (formData: Record<string, any>) => {
  analyticsBatcher.addEvent({
    action: 'form_success',
    category: 'conversion',
    label: 'form_completed',
    custom_parameters: {
      form_data: formData,
      success_timestamp: Date.now(),
    }
  });
};

/**
 * Track form error events
 */
export const trackFormError = (error: any) => {
  analyticsBatcher.addEvent({
    action: 'form_error',
    category: 'error',
    label: 'form_submission_failed',
    custom_parameters: {
      error_message: error?.message || 'Unknown error',
      error_type: error?.name || 'Error',
      error_timestamp: Date.now(),
    }
  });
};

/**
 * Track contact form submissions
 */
export const trackContactSubmission = (contactType: string, subject?: string) => {
  analyticsBatcher.addEvent({
    action: 'contact_submission',
    category: 'engagement',
    label: contactType,
    custom_parameters: {
      contact_type: contactType,
      contact_subject: subject,
    }
  });
};
